import { BaseTheme, Link, styled } from 'opensolar-ui'
import { REGISTER_LINK_MAPPING } from 'pages/ordering/detail/content/RegisterLink'
import { useDistributorConnect } from 'services/useDistributorConnect'
import { useTranslate } from 'react-admin'

const StyledLink = styled(Link)(({ theme }) => ({
  cursor: 'pointer',
  color: BaseTheme.palette.blue[900],
  textDecoration: 'underline',
}))

const SupplierConnectionLink = ({
  showConnectDistributorLink,
  selectedSupplier,
}: {
  showConnectDistributorLink: boolean
  selectedSupplier: string | undefined
}) => {
  const connectDistributor = useDistributorConnect()
  const translate = useTranslate()
  if (!showConnectDistributorLink) return null

  const handleClick = (event?: any) => {
    event?.stopPropagation()
    if (selectedSupplier === 'outlet') {
      window.open(REGISTER_LINK_MAPPING['outlet'], '_blank')
    } else if (selectedSupplier) {
      connectDistributor(selectedSupplier as any)
    }
  }
  return <StyledLink onClick={handleClick}>{translate('Connect to view pricing & stock')}</StyledLink>
}

export default SupplierConnectionLink
